import { Box, Button, Grid, Typography, Autocomplete, RadioGroup, FormControl, FormControlLabel, Radio } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from "yup";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FormSubmissionSuccessDialog from '../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import { cfpBaseUrl } from '../../../network/urls';
import "../../GeneralServices/NewConnection/NewConnectionForm.scss";
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../../components/AppLoader/AppLoader';
import { documentExtensions, portalName } from '../../../utils/PortalName';
import { resolveDiscoCompanyCodeForBranding } from '../../../utils/adminCompany';
import {
  buildCustomerIdYupRule,
  isValidCustomerIdLength,
} from '../../../utils/customerIdValidation';

import { companyShortName, handleFileUpload, getMeterChangeReason, isImage, isPdf, subdivisionName, subDivAPI, dBillAPI } from '../../../services/Functions';
import pdfIcon from '../../../images/pdfIcon.png';
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import mepcologo from "../../../images/mepcoLogo.png";
import Error from '../../../components/error/error';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';

const ShiftingToNetMeterForm = () => {
  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_circle: '',
    iv_division: '',
    iv_sub_divison: '',
    iv_address: '',
    // Installment Details field
    iv_meter_change_reason: 1,
    // Applicant Details group Initial Values
    iv_applicant_name: '',
    iv_father_name: '',
    iv_applicant_cnic: '',
    iv_applicant_phone_no: '',
    iv_applicant_email: '',
    // Required Documents Initial Values
    iv_last_paid_bill: '',
    iv_police_report: '',
    iv_connection_type: '',
    iv_tariff_description: '',
    iv_tariff_code: '',
  }

  const navigate = useNavigate();
  // Classification Group States
  const [applicationId, setApplicationId] = useState();
  const [referenceNumber, setReferenceNumber] = useState('');
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [address, setAddress] = useState('');
  const [meterPhase, setMeterPhase] = useState('');
  const [meterType, setMeterType] = useState('');
  const [meterStatus, setMeterStatus] = useState('');
  const [sactionedLoad, setSactionedLoad] = useState('');
  const [error, setError] = useState();
  // Documents states
  const [lastPaidBill, setLastPaidBill] = useState('');
  const [policeReport, setPoliceReport] = useState('');
  // Thumbnail states
  const [lastPaidBillThumbnail, setLastPaidBillThumbnail] = useState('');
  const [policeReportThumbnail, setPoliceReportThumbnail] = useState('');
  // Error States 
  const [lastBillError, setLastBillError] = useState('')
  const [policeReportError, setPoliceReportError] = useState('')
  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [meterChangeReason, setMeterChangeReason] = useState(1);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [meterChangePopUp, setMeterChangePopUp] = useState(false);
  const [searchBy, setSearchBy] = useState('consumerId');
  const { token, code: userCode, userId, name: userName, roleId, selectedAdminCompanyCode
  } = useSelector((state) => state.auth)
  let userCompany = resolveDiscoCompanyCodeForBranding(
    userCode,
    roleId,
    selectedAdminCompanyCode,
  );
  let userCircle = userCode.slice(0, 3);
  let userDivision = userCode.slice(0, 4);
  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );
   const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }

  const MeterChangeReason = (event) => {
    setMeterChangeReason(event.target.value);
    setPoliceReport('')
    setPoliceReportError('')
    setPoliceReportThumbnail('')
    mcrFormik.values.iv_police_report = ''
  };

  const SearchBy = (event) => {
    mcrFormik.values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle()
    setDefaultDivision()
    setSubDivision()
    setReferenceNumber()
    setAddress('')
    setLastPaidBillThumbnail('')
    setLastPaidBill('')
    setPoliceReportThumbnail('')
    setPoliceReport('')
    mcrFormik.values.iv_consumer_id = ''
    mcrFormik.values.iv_reference_number = ''
    mcrFormik.values.iv_circle = ''
    mcrFormik.values.iv_division = ''
    mcrFormik.values.iv_sub_divison = ''
    mcrFormik.values.iv_address = ''
    mcrFormik.values.iv_meter_change_reason = 1
    mcrFormik.values.iv_applicant_name = ''
    mcrFormik.values.iv_applicant_cnic = ''
    mcrFormik.values.iv_applicant_phone_no = ''
    mcrFormik.values.iv_applicant_email = ''
    mcrFormik.values.iv_last_paid_bill = ''
    mcrFormik.values.iv_police_report = ''
    mcrFormik.values.iv_father_name = ''
    mcrFormik.values.iv_connection_type = ''
    mcrFormik.values.iv_tariff_description = ''
    mcrFormik.values.iv_tariff_code = ''
  };

  // Formik form submission and Meter Change API calling
  const mcrFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      // Classification group Validations
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'consumerId',
        then: buildCustomerIdYupRule(userCompany),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.mixed().required("Please select a circle."),
      iv_division: Yup.mixed().required("Please select a division."),
      iv_sub_divison: Yup.mixed().required("Please select a sub division."),
      iv_meter_change_reason: Yup.mixed().required("Select reason for meter replacement!"),
      // Applicant Details group Validations
      iv_applicant_name: Yup.string().min(3, "Name should be atleast 3 characters.").max(30, "Name should be less than 30 characters.").optional("Please enter applicant name."),
      // iv_applicant_cnic: Yup.string().min(13, "Please enter 13 digit CNIC.").max(13, "Please enter 13 digit CNIC.").required("Please enter valid CNIC number.").matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
      iv_applicant_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.").min(11, "Please enter 11 digit phone number.").required("Please enter valid mobile number.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      // iv_applicant_email: Yup.string().email("Enter email as 'john@gmail.com'.").notRequired(),
      iv_last_paid_bill: Yup.mixed().required('Please upload last paid bill in jpg, jpeg, png format.'),
      iv_police_report: Yup.mixed().when('iv_meter_change_reason', {
        is: (iv_meter_change_reason) => (iv_meter_change_reason == 3),
        then: Yup.mixed().required('Please upload police report in jpg, jpeg, png format.'),
        otherwise: Yup.mixed().optional()
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true)

      var formdata = new FormData();
      formdata.append("refNo", referenceNumber);
      formdata.append("meterStatus", meterStatus ? meterStatus : "Unknown");
      formdata.append("meterType", meterType ? meterType : "MMR");
      formdata.append("meterPhase", meterPhase);
      formdata.append("sanctionedLoad", sactionedLoad ? sactionedLoad : 1);
      formdata.append("meterChangeType", mcrFormik.values.iv_meter_change_reason);
      formdata.append("name", mcrFormik.values.iv_applicant_name);
      formdata.append("applicantMobileNo", mcrFormik.values.iv_applicant_phone_no);
      formdata.append("applicantCNIC", mcrFormik.values.iv_applicant_cnic ? mcrFormik.values.iv_applicant_cnic : '0000000000000');
      formdata.append("address", address);
      formdata.append("lastBillImage", lastPaidBillThumbnail);
      formdata.append("policeReportImage", policeReportThumbnail);
      formdata.append("createdBy", userId);
      formdata.append("isOnline", 1);
      formdata.append("submittedThrough", portalName);
      formdata.append("subDivisionCode", subDivision.code);
      formdata.append("divisionCode", defaultDivision.code);
      formdata.append("circleCode", defaultCircle.code);
      formdata.append("companyCode", parseInt(defaultCircle.code.toString().slice(0, 2)));
      formdata.append("cfcId", userCode);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfMeterRequest/changeOfMeterRequest", requestOptions)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          } else {
          }
        })
        .then(result => {
          if (result.status === '200') {
            const applicationID = result.changeOfMeterRequestId
            setMeterChangePopUp(true)
            resetForm()
            setDefaultCircle()
            setDefaultDivision()
            setSubDivision()
            setAddress('')
            setLastPaidBillThumbnail('')
            setLastPaidBill('')
            setPoliceReportThumbnail('')
            setPoliceReport('')
            setReferenceNumber()
            mcrFormik.values.iv_address = ''
            setApplicationId(applicationID)
            printApplicationReceipt(values, applicationID, userName, referenceNumber);
          }
          else {
          }
        })
        .catch(() => {});
      setViewBackdrop(false)
    }
  })

  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(userCompany, cfpBaseUrl, token)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(subDivision => subDivision.divisionCode === defaultDivision.code)
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(s => s.code === subDivision.subDivisionCode);
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);

  // Calling Billing API to fetch near by details
  useEffect(() => {
    if (isValidCustomerIdLength(mcrFormik.values.iv_consumer_id, userCompany)) {
      referenceApi();
    } else {
      setDefaultCircle()
      setDefaultDivision()
      setReferenceNumber()
      setSubDivision()
      setAddress('')
      setError('')
      setLastPaidBillThumbnail('')
      setLastPaidBill('')
      setPoliceReportThumbnail('')
      setPoliceReport('')
      mcrFormik.values.iv_reference_number = ''
      mcrFormik.values.iv_circle = ''
      mcrFormik.values.iv_division = ''
      mcrFormik.values.iv_sub_divison = ''
      mcrFormik.values.iv_address = ''
      mcrFormik.values.iv_meter_change_reason = 1
      mcrFormik.values.iv_applicant_name = ''
      mcrFormik.values.iv_applicant_cnic = ''
      mcrFormik.values.iv_applicant_phone_no = ''
      mcrFormik.values.iv_applicant_email = ''
      mcrFormik.values.iv_last_paid_bill = ''
      mcrFormik.values.iv_police_report = ''
      mcrFormik.values.iv_father_name = ''
      mcrFormik.values.iv_connection_type = ''
      mcrFormik.values.iv_tariff_description = ''
      mcrFormik.values.iv_tariff_code = ''
    }
  }, [mcrFormik.values.iv_consumer_id])

  useEffect(() => {
    if (mcrFormik.values.iv_reference_number.length === 14) {
      referenceApi();
    } else {
      setDefaultCircle()
      setDefaultDivision()
      setReferenceNumber()
      setSubDivision()
      setError('')
      setAddress('')
      setLastPaidBillThumbnail('')
      setLastPaidBill('')
      setPoliceReportThumbnail('')
      setPoliceReport('')
      mcrFormik.values.iv_consumer_id = ''
      mcrFormik.values.iv_circle = ''
      mcrFormik.values.iv_division = ''
      mcrFormik.values.iv_sub_divison = ''
      mcrFormik.values.iv_address = ''
      mcrFormik.values.iv_meter_change_reason = 1
      mcrFormik.values.iv_applicant_name = ''
      mcrFormik.values.iv_applicant_cnic = ''
      mcrFormik.values.iv_applicant_phone_no = ''
      mcrFormik.values.iv_applicant_email = ''
      mcrFormik.values.iv_last_paid_bill = ''
      mcrFormik.values.iv_police_report = ''
      mcrFormik.values.iv_father_name = ''
      mcrFormik.values.iv_connection_type = ''
      mcrFormik.values.iv_tariff_description = ''
      mcrFormik.values.iv_tariff_code = ''
    }
  }, [mcrFormik.values.iv_reference_number])

  useEffect(() => {
    if (referenceNumber) {
      let circleCode = referenceNumber.slice(2, 5)
      let circleObject = circleList.find(item => item.code === parseInt(circleCode))
      setDefaultCircle(circleObject)
      mcrFormik.values.iv_circle = circleObject.code

      let divisionCode = referenceNumber.slice(2, 6)
      let subDivisionCode = referenceNumber.slice(2, 7)

      let uniqueDivisions = []

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
        var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (divisionA < divisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (divisionA > divisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode))

      setDefaultDivision(defDivision)
      mcrFormik.values.iv_division = defDivision.code
      setDivisionList(sortedDivisionArray)

      let uniqueSubDivisions = []

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort(function (a, b) {
        var subDivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var subDivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (subDivisionA < subDivisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (subDivisionA > subDivisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode))
      mcrFormik.values.iv_sub_divison = subDivisionObject.code
      setSubDivision(subDivisionObject)
      setSubDivisionList(sortedSubDivisionArray)
    }
  }, [referenceNumber])

  // Function to fetch sub division and near by name and address through API 
  const referenceApi = async () => {
    if (searchBy === 'consumerId') {
      setViewBackdrop(true)
      if (!mcrFormik.values.iv_consumer_id) return;
      let apiResponse = await dBillAPI(token, mcrFormik.values.iv_consumer_id)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        const meterInfo = apiResponse.metersInfo
        setAddress(basicInfo.consumerAddress1 + basicInfo.consumerAddress2)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setMeterType(basicInfo.meterType)
        setSactionedLoad(basicInfo.sactionLoad)
        mcrFormik.values.iv_applicant_name = basicInfo.consumerName
        mcrFormik.values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        mcrFormik.values.iv_father_name = basicInfo.consumerFName
        mcrFormik.values.iv_applicant_cnic = basicInfo.owner_cnic
        mcrFormik.values.iv_applicant_phone_no = basicInfo.consumerContactNo
        mcrFormik.values.iv_applicant_email = basicInfo.consumerEmail
        mcrFormik.values.iv_connection_type = basicInfo.cons_cat
        mcrFormik.values.iv_tariff_description = basicInfo.tariffDescription
        mcrFormik.values.iv_tariff_code = basicInfo.tariffCode
        if (basicInfo.phase) {
          setMeterPhase(basicInfo.phase)

        }
        else {
          let phase = '';
          if (meterInfo.length === 1) {
            phase = "Single Phase"
          }
          else if (meterInfo.length >= 2) {
            phase = "3 Phase"
          }
          setMeterPhase(phase)
        }
        setMeterStatus(meterInfo[0].mtrStatus)
      } else if (apiResponse.status == false) {
        setError('No Data Found against this Customer ID.')
      }else {
        setError('Customer ID. not found!')
      }
      setViewBackdrop(false)
    }

    if (searchBy === 'referenceNo') {
      setViewBackdrop(true)
      if (!mcrFormik.values.iv_reference_number) return;
      let apiResponse = await dBillAPI(token, mcrFormik.values.iv_reference_number)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        const meterInfo = apiResponse.metersInfo
        setAddress(basicInfo.consumerAddress1 + basicInfo.consumerAddress2)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setMeterType(basicInfo.meterType)
        setSactionedLoad(basicInfo.sactionLoad)
        mcrFormik.values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        mcrFormik.values.iv_applicant_name = basicInfo.consumerName
        mcrFormik.values.iv_father_name = basicInfo.consumerFName
        mcrFormik.values.iv_applicant_cnic = basicInfo.occupant_cnic
        mcrFormik.values.iv_applicant_phone_no = basicInfo.consumerContactNo
        mcrFormik.values.iv_applicant_email = basicInfo.consumerEmail
        mcrFormik.values.iv_connection_type = basicInfo.cons_cat
        mcrFormik.values.iv_tariff_description = basicInfo.tariffDescription
        mcrFormik.values.iv_tariff_code = basicInfo.tariffCode
        if (basicInfo.phase) {
          setMeterPhase(basicInfo.phase)
        }
        else {
          let phase = '';
          if (meterInfo.length === 1) {
            phase = "S-PHASE"
          }
          else if (meterInfo.length >= 2) {
            phase = "3-PHASE"
          }
          setMeterPhase(phase)
        }
        setMeterStatus(meterInfo[0].mtrStatus)
      }else if (apiResponse.status == false) {
        setError('No Data Found against this Reference No.')
      }
      else {
        setError('Reference No. not found!')
      }
      setViewBackdrop(false)
    }
  };

  const LastPaidBill = (event) => {
    if (event.target.files) {
      const newFileName = 'LastBillDocument.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mcrFormik.handleChange, setLastPaidBill, setLastBillError, setLastPaidBillThumbnail, newFileName);
    }
  }

  const PoliceReport = (event) => {
    if (event.target.files) {
      const newFileName = 'PoliceReport.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, mcrFormik.handleChange, setPoliceReport, setPoliceReportError, setPoliceReportThumbnail, newFileName);
    }
  }

  const handleClose = () => {
    setMeterChangePopUp(false);
    navigate('/meter-change-request-table')
  };

  const printApplicationReceipt = (values, applicationID, userName, referenceNo) => {
    const doc = new jsPDF({ compressPdf: true });

    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(mepcologo, "PNG", 90, height, 30, 10); // Adjust the position and size of the barcode image

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Meter Change Application",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height
    );
    doc.text(
      values.iv_sub_divison.toString() +
      " / " +
      subdivisionName(values.iv_sub_divison, subDivisionsArray),
      padding + leftMargin,
      height
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Reason: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(getMeterChangeReason(values.iv_meter_change_reason.toString()), padding + leftMargin, height);


    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userName, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(userCompany),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight()
      );
    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, '_blank');

  };

  const errorCloses = () => {
    setError('')
  }

  const [mCStatusBarArray, setMCStatusBarArray] = useState([{
    title1: 'APPLICATION',
    title2: 'DETAIL',
    status: 0
  }, {
    title1: 'LAST PAID',
    title2: 'BILL',
    status: 0
  }]);

  useEffect(() => {
    if (meterChangeReason) {
      mcrFormik.values.iv_meter_change_reason = meterChangeReason;

      setMCStatusBarArray(prevArray => {
        const newArray = [];

        if (meterChangeReason === '3') {
          newArray.push(
            ...[
              {
                title1: 'APPLICATION',
                title2: 'DETAIL',
                status: prevArray[0]?.status || 0
              },
              {
                title1: `LAST PAID`,
                title2: 'BILL',
                status: prevArray[1]?.status || 0
              },
              {
                title1: 'POLICE',
                title2: 'REPORT',
                status: prevArray[2]?.status || 0
              },
            ]
          )
        } else {
          newArray.push(
            ...[
              {
                title1: 'APPLICATION',
                title2: 'DETAIL',
                status: prevArray[0]?.status || 0
              },
              {
                title1: `LAST PAID`,
                title2: 'BILL',
                status: prevArray[1]?.status || 0
              }
            ]
          )
        }

        return newArray;
      })
    }
  }, [meterChangeReason])

  useEffect(() => {
    if ((mcrFormik.values.iv_consumer_id || mcrFormik.values.iv_reference_number)
      && mcrFormik.values.iv_applicant_name
      && mcrFormik.values.iv_applicant_phone_no
      && mcrFormik.values.iv_meter_change_reason
    ) {
      setMCStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setMCStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [mcrFormik.values])

  useEffect(() => {
    if (lastPaidBill) {
      setMCStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setMCStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [lastPaidBill])

  useEffect(() => {
    if (meterChangeReason === '3') {
      if (policeReport) {
        setMCStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[2] = {
            ...updatedArray[2],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setMCStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[2] = {
            ...updatedArray[2],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [policeReport])

  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer'>
          <div className="headingBarDiv">
            <h3 className="heading">
              Shifting To Net Meter
            </h3>
            <StepProgressBar array={mCStatusBarArray} />
          </div>
          <form className='ncform'>
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              Applicant's Details
            </Typography>
            <CustomerInformationCard
              searchBy={searchBy}
              SearchBy={SearchBy}
              errors={mcrFormik.errors}
              values={mcrFormik.values}
              touched={mcrFormik.touched}
              handleChange={mcrFormik.handleChange}
              handleBlur={mcrFormik.handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
            />
            {/* <Grid container className='container'>
              <Grid item xs={3}>
                <Typography className="fieldLabel"> Search By</Typography>
                <FormControl className="form-control"  >
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_search_by"
                    defaultValue={searchBy}
                    value={searchBy}
                    onChange={SearchBy}
                  >
                    <FormControlLabel
                      value="consumerId"
                      className="form-control-label"
                      control={<Radio />}
                      label="Customer ID."
                      name="consumerId"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="referenceNo"
                      className="form-control-label"
                      control={<Radio />}
                      label="Reference No."
                      name="referenceNo"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {
                searchBy === 'consumerId' &&
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Customer ID.</Typography>
                  <TextField
                    type='text'
                    name="iv_consumer_id"
                    autoComplete='off'
                    value={mcrFormik.values.iv_consumer_id}
                    onChange={mcrFormik.handleChange}
                    onBlur={mcrFormik.handleBlur}
                    inputProps={{ maxLength: 10 }}
                    id="iv_consumer_id"
                    className='textInputField'
                  />
                  <Box className='from-Error'>
                    {mcrFormik.errors.iv_consumer_id && mcrFormik.touched.iv_consumer_id ? (mcrFormik.errors.iv_consumer_id) : null}
                  </Box>
                </Grid>
              }
              {
                searchBy === 'referenceNo' &&
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reference No.</Typography>
                  <TextField
                    type='text'
                    name="iv_reference_number"
                    autoComplete='off'
                    value={mcrFormik.values.iv_reference_number}
                    onChange={mcrFormik.handleChange}
                    onBlur={mcrFormik.handleBlur}
                    inputProps={{ maxLength: 14 }}
                    id="iv_reference_number"
                    className='textInputField'
                  />
                  <Box className='from-Error'>
                    {mcrFormik.errors.iv_reference_number && mcrFormik.touched.iv_reference_number ? (mcrFormik.errors.iv_reference_number) : null}
                  </Box>
                </Grid>
              }
              <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Name</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_applicant_name"
                  value={mcrFormik.values.iv_applicant_name}
                  autoComplete='off'
                  disabled
                  onChange={mcrFormik.handleChange}
                  onBlur={mcrFormik.handleBlur}
                  id="iv_applicant_name"
                  className='textInputField1'
                />
                <Box className='from-Error'>
                  {mcrFormik.errors.iv_applicant_name && mcrFormik.touched.iv_applicant_name ? (mcrFormik.errors.iv_applicant_name) : null}
                </Box>
              </Grid>
              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Father Name</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_applicant_cnic"
                  disabled
                  value={mcrFormik.values.iv_applicant_cnic}
                  onChange={mcrFormik.handleChange}
                  onBlur={mcrFormik.handleBlur}
                  id="iv_applicant_cnic"
                  className='textInputField1'
                  inputProps={{ maxLength: 13, autoComplete: 'off' }}
                />
                <Box className='from-Error'>
                  {mcrFormik.errors.iv_applicant_cnic && mcrFormik.touched.iv_applicant_cnic ? (mcrFormik.errors.iv_applicant_cnic) : null}
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Typography className='fieldLabel'  >Phone No.</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_applicant_phone_no"
                  autoComplete='nope'
                  value={mcrFormik.values.iv_applicant_phone_no}
                  onChange={mcrFormik.handleChange}
                  onBlur={mcrFormik.handleBlur}
                  inputProps={{ maxLength: 11, autoComplete: 'off' }}
                  id="iv_applicant_phone_no"
                  className='textInputField'
                />
                <Box className='from-Error'>
                  {mcrFormik.errors.iv_applicant_phone_no && mcrFormik.touched.iv_applicant_phone_no ? (mcrFormik.errors.iv_applicant_phone_no) : null}
                </Box>
              </Grid>
              <Grid item lg={2.5} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Circle</Typography>
                <Autocomplete
                  id="iv_circle"
                  name="iv_circle"
                  disabled
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      display: 'none', // Hides the down arrow
                    },
                  }}
                  value={defaultCircle ? defaultCircle : null}
                  options={circleList}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setDefaultCircle(value);
                      mcrFormik.values.iv_circle = value.code
                    }
                  }}
                />
                <Box className='from-Error'>
                  {mcrFormik.errors.iv_circle && mcrFormik.touched.iv_circle ? (mcrFormik.errors.iv_circle) : null}
                </Box>
              </Grid>
              <Grid item lg={2.5} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Division</Typography>
                <Autocomplete
                  id="iv_division"
                  name="iv_division"
                  disabled
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      display: 'none', // Hides the down arrow
                    },
                  }}
                  options={divisionList}
                  value={defaultDivision ? defaultDivision : null}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setDefaultDivision(value);
                      mcrFormik.values.iv_division = value.code
                    }
                  }}
                />
                <Box className='from-Error'>
                  {mcrFormik.errors.iv_division && mcrFormik.touched.iv_division ? (mcrFormik.errors.iv_division) : null}
                </Box>
              </Grid>
              <Grid item lg={2.5} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Sub-Division</Typography>
                <Autocomplete
                  id="iv_sub_divison"
                  value={subDivision ? subDivision : null}
                  name="iv_sub_divison"
                  disabled
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      display: 'none', // Hides the down arrow
                    },
                  }}
                  options={subDivisionList}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setSubDivision(value);
                      mcrFormik.values.iv_sub_divison = value.code
                    }
                  }}
                />
                <Box className='from-Error'>
                  {mcrFormik.errors.iv_sub_divison && mcrFormik.touched.iv_sub_divison ? (mcrFormik.errors.iv_sub_divison) : null}
                </Box>
              </Grid>
              <Grid item lg={4.5}>
                <Typography className='fieldLabel'>Address</Typography>
                <TextField
                  name='iv_address'
                  id='iv_address'
                  required
                  type='text'
                  onBlur={mcrFormik.handleBlur}
                  onChange={mcrFormik.handleChange}
                  value={address}
                  disabled
                  className='textInputFieldAddressing' />
              </Grid>
            </Grid> */}
            {/* <Typography variant="h6" className="groupTitle">
              <div className="cyanCell">
              </div>
              Meter Change Reason
            </Typography> */}
            {/* <Grid container className='container'>
              <Grid item xs={6}>
                <FormControl className='form-control' >
                  <RadioGroup
                    className='radio-group'
                    row
                    name="iv_meterChange_reason"
                    defaultValue={meterChangeReason}
                    value={meterChangeReason}
                    onChange={MeterChangeReason}
                  >
                    <FormControlLabel
                      value={1}
                      className='form-control-label'
                      control={<Radio />}
                      label="No Display"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={2}
                      className='form-control-label'
                      control={<Radio />}
                      label="Meter Terminal Burnt"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={3}
                      className='form-control-label'
                      control={<Radio />}
                      label="Meter Stolen"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={4}
                      className='form-control-label'
                      control={<Radio />}
                      label="Net Metering"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
                <Box className='from-Error'>
                  {mcrFormik.errors.iv_meter_change_reason && mcrFormik.touched.iv_meter_change_reason ? (mcrFormik.errors.iv_meter_change_reason) : null}
                </Box>
              </Grid>
            </Grid> */}
            <Typography variant="h6" className="groupTitleDocuments">
              Required Documents
            </Typography>
            <Grid style={{ display: 'flex', flexDirection: 'row' }}>
              <Grid container className='document-container' style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid item lg={12}>
                  <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                    <Grid item lg={5} >
                      <Typography className='documentLabel' >1- CNIC Copy</Typography>
                      <Box className='documentError'>{mcrFormik.errors.iv_last_paid_bill && mcrFormik.touched.iv_last_paid_bill ? (mcrFormik.errors.iv_last_paid_bill) : null} {lastBillError && lastBillError}</Box>
                    </Grid>
                    <Grid item lg={2}>
                      {
                        lastPaidBill ?
                          <>
                            <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setLastPaidBill('') }} />}  >
                              {lastPaidBillThumbnail && isImage(lastPaidBill) ? (
                                <div className='btn-div'>
                                  <img src={lastPaidBillThumbnail} alt="Last Bill" width="80" />
                                  {/* <p style={{ width: '50px', fontSize:'8px' }}>{lastPaidBillFileName}</p> */}
                                </div>
                              ) : (
                                <span>{isPdf(lastPaidBill) ?
                                  <div className='btn-div'>
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                    {/* <p style={{ maxWidth: '50px' }}>{lastPaidBillFileName}</p> */}
                                  </div>
                                  : "Other file type"}</span>
                              )}
                            </Button>
                          </>
                          :
                          <>
                            <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                              Upload
                              <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                            </Button>
                          </>
                      }
                    </Grid>
                    {
                      meterChangeReason == 3 &&
                      <>
                        <Grid item lg={2} >
                          <Typography className='documentLabel' >2- Police Report.</Typography>
                          <Box className='documentError'>{mcrFormik.errors.iv_police_report && mcrFormik.touched.iv_police_report ? (mcrFormik.errors.iv_police_report) : null} {policeReportError && policeReportError}</Box>
                        </Grid>
                        <Grid item lg={2}>
                          {
                            policeReport ?
                              <>
                                <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setPoliceReport('') }} />}  >
                                  {policeReportThumbnail && isImage(policeReport) ? (
                                    <div className='btn-div'>
                                      <img src={policeReportThumbnail} alt="Police Report" width="80" />
                                      {/* <p>{policeReportFileName}</p> */}
                                    </div>
                                  ) : (
                                    <span>{isPdf(policeReport) ?
                                      <div className='btn-div'>
                                        <img src={pdfIcon} alt="PDF" width="80" />
                                        {/* <p>{policeReportFileName}</p> */}
                                      </div>
                                      : "Other file type"}</span>
                                  )}
                                </Button>
                              </>
                              :
                              <>
                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                  Upload
                                  <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                </Button>
                              </>
                          }
                        </Grid>
                      </>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className='document-container' style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid item lg={12}>
                  <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                    <Grid item lg={5} >
                      <Typography className='documentLabel' >2- File Front Page</Typography>
                      <Box className='documentError'>{mcrFormik.errors.iv_last_paid_bill && mcrFormik.touched.iv_last_paid_bill ? (mcrFormik.errors.iv_last_paid_bill) : null} {lastBillError && lastBillError}</Box>
                    </Grid>
                    <Grid item lg={2}>
                      {
                        lastPaidBill ?
                          <>
                            <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setLastPaidBill('') }} />}  >
                              {lastPaidBillThumbnail && isImage(lastPaidBill) ? (
                                <div className='btn-div'>
                                  <img src={lastPaidBillThumbnail} alt="Last Bill" width="80" />
                                  {/* <p style={{ width: '50px', fontSize:'8px' }}>{lastPaidBillFileName}</p> */}
                                </div>
                              ) : (
                                <span>{isPdf(lastPaidBill) ?
                                  <div className='btn-div'>
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                    {/* <p style={{ maxWidth: '50px' }}>{lastPaidBillFileName}</p> */}
                                  </div>
                                  : "Other file type"}</span>
                              )}
                            </Button>
                          </>
                          :
                          <>
                            <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                              Upload
                              <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                            </Button>
                          </>
                      }
                    </Grid>
                    {
                      meterChangeReason == 3 &&
                      <>
                        <Grid item lg={2} >
                          <Typography className='documentLabel' >2- Police Report.</Typography>
                          <Box className='documentError'>{mcrFormik.errors.iv_police_report && mcrFormik.touched.iv_police_report ? (mcrFormik.errors.iv_police_report) : null} {policeReportError && policeReportError}</Box>
                        </Grid>
                        <Grid item lg={2}>
                          {
                            policeReport ?
                              <>
                                <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setPoliceReport('') }} />}  >
                                  {policeReportThumbnail && isImage(policeReport) ? (
                                    <div className='btn-div'>
                                      <img src={policeReportThumbnail} alt="Police Report" width="80" />
                                      {/* <p>{policeReportFileName}</p> */}
                                    </div>
                                  ) : (
                                    <span>{isPdf(policeReport) ?
                                      <div className='btn-div'>
                                        <img src={pdfIcon} alt="PDF" width="80" />
                                        {/* <p>{policeReportFileName}</p> */}
                                      </div>
                                      : "Other file type"}</span>
                                  )}
                                </Button>
                              </>
                              :
                              <>
                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                  Upload
                                  <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                </Button>
                              </>
                          }
                        </Grid>
                      </>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className='document-container' style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid item lg={12}>
                  <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                    <Grid item lg={5} >
                      <Typography className='documentLabel' >3- Sign Agreement</Typography>
                      <Box className='documentError'>{mcrFormik.errors.iv_last_paid_bill && mcrFormik.touched.iv_last_paid_bill ? (mcrFormik.errors.iv_last_paid_bill) : null} {lastBillError && lastBillError}</Box>
                    </Grid>
                    <Grid item lg={2}>
                      {
                        lastPaidBill ?
                          <>
                            <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setLastPaidBill('') }} />}  >
                              {lastPaidBillThumbnail && isImage(lastPaidBill) ? (
                                <div className='btn-div'>
                                  <img src={lastPaidBillThumbnail} alt="Last Bill" width="80" />
                                  {/* <p style={{ width: '50px', fontSize:'8px' }}>{lastPaidBillFileName}</p> */}
                                </div>
                              ) : (
                                <span>{isPdf(lastPaidBill) ?
                                  <div className='btn-div'>
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                    {/* <p style={{ maxWidth: '50px' }}>{lastPaidBillFileName}</p> */}
                                  </div>
                                  : "Other file type"}</span>
                              )}
                            </Button>
                          </>
                          :
                          <>
                            <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                              Upload
                              <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                            </Button>
                          </>
                      }
                    </Grid>
                    {
                      meterChangeReason == 3 &&
                      <>
                        <Grid item lg={2} >
                          <Typography className='documentLabel' >2- Police Report.</Typography>
                          <Box className='documentError'>{mcrFormik.errors.iv_police_report && mcrFormik.touched.iv_police_report ? (mcrFormik.errors.iv_police_report) : null} {policeReportError && policeReportError}</Box>
                        </Grid>
                        <Grid item lg={2}>
                          {
                            policeReport ?
                              <>
                                <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setPoliceReport('') }} />}  >
                                  {policeReportThumbnail && isImage(policeReport) ? (
                                    <div className='btn-div'>
                                      <img src={policeReportThumbnail} alt="Police Report" width="80" />
                                      {/* <p>{policeReportFileName}</p> */}
                                    </div>
                                  ) : (
                                    <span>{isPdf(policeReport) ?
                                      <div className='btn-div'>
                                        <img src={pdfIcon} alt="PDF" width="80" />
                                        {/* <p>{policeReportFileName}</p> */}
                                      </div>
                                      : "Other file type"}</span>
                                  )}
                                </Button>
                              </>
                              :
                              <>
                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                  Upload
                                  <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                </Button>
                              </>
                          }
                        </Grid>
                      </>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className='document-container' style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid item lg={12}>
                  <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                    <Grid item lg={8} >
                      <Typography className='documentLabel' >4- PPIB / AEDB Certificate</Typography>
                      <Box className='documentError'>{mcrFormik.errors.iv_last_paid_bill && mcrFormik.touched.iv_last_paid_bill ? (mcrFormik.errors.iv_last_paid_bill) : null} {lastBillError && lastBillError}</Box>
                    </Grid>
                    <Grid item lg={2}>
                      {
                        lastPaidBill ?
                          <>
                            <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setLastPaidBill('') }} />}  >
                              {lastPaidBillThumbnail && isImage(lastPaidBill) ? (
                                <div className='btn-div'>
                                  <img src={lastPaidBillThumbnail} alt="Last Bill" width="80" />
                                  {/* <p style={{ width: '50px', fontSize:'8px' }}>{lastPaidBillFileName}</p> */}
                                </div>
                              ) : (
                                <span>{isPdf(lastPaidBill) ?
                                  <div className='btn-div'>
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                    {/* <p style={{ maxWidth: '50px' }}>{lastPaidBillFileName}</p> */}
                                  </div>
                                  : "Other file type"}</span>
                              )}
                            </Button>
                          </>
                          :
                          <>
                            <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                              Upload
                              <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                            </Button>
                          </>
                      }
                    </Grid>
                    {
                      meterChangeReason == 3 &&
                      <>
                        <Grid item lg={2} >
                          <Typography className='documentLabel' >2- Police Report.</Typography>
                          <Box className='documentError'>{mcrFormik.errors.iv_police_report && mcrFormik.touched.iv_police_report ? (mcrFormik.errors.iv_police_report) : null} {policeReportError && policeReportError}</Box>
                        </Grid>
                        <Grid item lg={2}>
                          {
                            policeReport ?
                              <>
                                <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setPoliceReport('') }} />}  >
                                  {policeReportThumbnail && isImage(policeReport) ? (
                                    <div className='btn-div'>
                                      <img src={policeReportThumbnail} alt="Police Report" width="80" />
                                      {/* <p>{policeReportFileName}</p> */}
                                    </div>
                                  ) : (
                                    <span>{isPdf(policeReport) ?
                                      <div className='btn-div'>
                                        <img src={pdfIcon} alt="PDF" width="80" />
                                        {/* <p>{policeReportFileName}</p> */}
                                      </div>
                                      : "Other file type"}</span>
                                  )}
                                </Button>
                              </>
                              :
                              <>
                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                  Upload
                                  <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                </Button>
                              </>
                          }
                        </Grid>
                      </>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className='document-container' style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid item lg={12}>
                  <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                    <Grid item lg={8} >
                      <Typography className='documentLabel' >5- Installer Inspection Certificate</Typography>
                      <Box className='documentError'>{mcrFormik.errors.iv_last_paid_bill && mcrFormik.touched.iv_last_paid_bill ? (mcrFormik.errors.iv_last_paid_bill) : null} {lastBillError && lastBillError}</Box>
                    </Grid>
                    <Grid item lg={2}>
                      {
                        lastPaidBill ?
                          <>
                            <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setLastPaidBill('') }} />}  >
                              {lastPaidBillThumbnail && isImage(lastPaidBill) ? (
                                <div className='btn-div'>
                                  <img src={lastPaidBillThumbnail} alt="Last Bill" width="80" />
                                  {/* <p style={{ width: '50px', fontSize:'8px' }}>{lastPaidBillFileName}</p> */}
                                </div>
                              ) : (
                                <span>{isPdf(lastPaidBill) ?
                                  <div className='btn-div'>
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                    {/* <p style={{ maxWidth: '50px' }}>{lastPaidBillFileName}</p> */}
                                  </div>
                                  : "Other file type"}</span>
                              )}
                            </Button>
                          </>
                          :
                          <>
                            <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                              Upload
                              <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                            </Button>
                          </>
                      }
                    </Grid>
                    {
                      meterChangeReason == 3 &&
                      <>
                        <Grid item lg={2} >
                          <Typography className='documentLabel' >2- Police Report.</Typography>
                          <Box className='documentError'>{mcrFormik.errors.iv_police_report && mcrFormik.touched.iv_police_report ? (mcrFormik.errors.iv_police_report) : null} {policeReportError && policeReportError}</Box>
                        </Grid>
                        <Grid item lg={2}>
                          {
                            policeReport ?
                              <>
                                <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setPoliceReport('') }} />}  >
                                  {policeReportThumbnail && isImage(policeReport) ? (
                                    <div className='btn-div'>
                                      <img src={policeReportThumbnail} alt="Police Report" width="80" />
                                      {/* <p>{policeReportFileName}</p> */}
                                    </div>
                                  ) : (
                                    <span>{isPdf(policeReport) ?
                                      <div className='btn-div'>
                                        <img src={pdfIcon} alt="PDF" width="80" />
                                        {/* <p>{policeReportFileName}</p> */}
                                      </div>
                                      : "Other file type"}</span>
                                  )}
                                </Button>
                              </>
                              :
                              <>
                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                  Upload
                                  <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                </Button>
                              </>
                          }
                        </Grid>
                      </>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className='document-container' style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid item lg={12}>
                  <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                    <Grid item lg={6} >
                      <Typography className='documentLabel' >6- others Documents</Typography>
                      <Box className='documentError'>{mcrFormik.errors.iv_last_paid_bill && mcrFormik.touched.iv_last_paid_bill ? (mcrFormik.errors.iv_last_paid_bill) : null} {lastBillError && lastBillError}</Box>
                    </Grid>
                    <Grid item lg={2}>
                      {
                        lastPaidBill ?
                          <>
                            <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setLastPaidBill('') }} />}  >
                              {lastPaidBillThumbnail && isImage(lastPaidBill) ? (
                                <div className='btn-div'>
                                  <img src={lastPaidBillThumbnail} alt="Last Bill" width="80" />
                                  {/* <p style={{ width: '50px', fontSize:'8px' }}>{lastPaidBillFileName}</p> */}
                                </div>
                              ) : (
                                <span>{isPdf(lastPaidBill) ?
                                  <div className='btn-div'>
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                    {/* <p style={{ maxWidth: '50px' }}>{lastPaidBillFileName}</p> */}
                                  </div>
                                  : "Other file type"}</span>
                              )}
                            </Button>
                          </>
                          :
                          <>
                            <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                              Upload
                              <input hidden accept={documentExtensions} id='iv_last_paid_bill' name='iv_last_paid_bill' type="file" onChange={LastPaidBill} />
                            </Button>
                          </>
                      }
                    </Grid>
                    {
                      meterChangeReason == 3 &&
                      <>
                        <Grid item lg={2} >
                          <Typography className='documentLabel' >2- Police Report.</Typography>
                          <Box className='documentError'>{mcrFormik.errors.iv_police_report && mcrFormik.touched.iv_police_report ? (mcrFormik.errors.iv_police_report) : null} {policeReportError && policeReportError}</Box>
                        </Grid>
                        <Grid item lg={2}>
                          {
                            policeReport ?
                              <>
                                <Button component="label" startIcon={<CloseIcon className='button-with-image' onClick={() => { setPoliceReport('') }} />}  >
                                  {policeReportThumbnail && isImage(policeReport) ? (
                                    <div className='btn-div'>
                                      <img src={policeReportThumbnail} alt="Police Report" width="80" />
                                      {/* <p>{policeReportFileName}</p> */}
                                    </div>
                                  ) : (
                                    <span>{isPdf(policeReport) ?
                                      <div className='btn-div'>
                                        <img src={pdfIcon} alt="PDF" width="80" />
                                        {/* <p>{policeReportFileName}</p> */}
                                      </div>
                                      : "Other file type"}</span>
                                  )}
                                </Button>
                              </>
                              :
                              <>
                                <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                  Upload
                                  <input hidden accept={documentExtensions} id='iv_police_report' name='iv_police_report' type="file" onChange={PoliceReport} />
                                </Button>
                              </>
                          }
                        </Grid>
                      </>
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button
                className={((!isValidCustomerIdLength(mcrFormik.values.iv_consumer_id, userCompany) || mcrFormik.values.iv_reference_number.length != 14) && mcrFormik.values.iv_applicant_phone_no != '' && mcrFormik.values.iv_last_paid_bill != '') === false ? 'disabled-button' : 'button'}
                variant="contained" component="label" disabled={((!isValidCustomerIdLength(mcrFormik.values.iv_consumer_id, userCompany) || mcrFormik.values.iv_reference_number.length != 14) && mcrFormik.values.iv_applicant_phone_no != '' && mcrFormik.values.iv_last_paid_bill != '') === false} type='submit' onClick={mcrFormik.handleSubmit}>
                Submit
              </Button>
            </Box>
          </form >
        </Box >
      </Grid >

      <FormSubmissionSuccessDialog
        open={meterChangePopUp}
        onClose={handleClose}
        title="Request submitted"
        message="Your Meter Change Request is submitted successfully."
        trackingId={applicationId}
      />

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>
  );
}

export default ShiftingToNetMeterForm;
